import { useState } from "react";
import api from "../../api/axois";

export default function ReviewForm({ bookingId, onReviewSubmitted }) {
  const [rating, setRating] = useState(0);
  const [hovered, setHovered] = useState(0);
  const [comment, setComment] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  if (!bookingId) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (rating === 0) { setError("Please select a star rating."); return; }
    setSubmitting(true);
    setError("");
    setSuccess("");
    try {
      await api.post(`/bookings/${bookingId}/reviews`, { rating, comment });
      setSuccess("Thank you! Your review has been submitted.");
      setRating(0);
      setComment("");
      if (onReviewSubmitted) onReviewSubmitted();
    } catch (err) {
      setError(err.response?.data?.message || "Failed to submit review. You may have already reviewed this booking.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} style={{ maxWidth: 480 }}>
      {/* Star rating */}
      <div style={{ display: "flex", gap: 6, marginBottom: 14 }}>
        {[1, 2, 3, 4, 5].map((s) => (
          <span
            key={s}
            onClick={() => setRating(s)}
            onMouseEnter={() => setHovered(s)}
            onMouseLeave={() => setHovered(0)}
            style={{
              fontSize: 30,
              cursor: "pointer",
              color: s <= (hovered || rating) ? "#d4af37" : "#d1d5db",
              transition: "color 0.15s",
            }}
            aria-label={`${s} star${s > 1 ? "s" : ""}`}
          >
            ★
          </span>
        ))}
        {rating > 0 && (
          <span style={{ alignSelf: "center", fontSize: 13, color: "#718096", marginLeft: 4 }}>
            {["", "Poor", "Fair", "Good", "Very good", "Excellent"][rating]}
          </span>
        )}
      </div>

      <textarea
        value={comment}
        onChange={(e) => setComment(e.target.value)}
        placeholder="Share your experience (optional)…"
        rows={4}
        maxLength={2000}
        style={{
          width: "100%",
          padding: "10px 12px",
          borderRadius: 8,
          border: "1px solid #d1d5db",
          fontSize: 14,
          resize: "vertical",
          fontFamily: "inherit",
          boxSizing: "border-box",
        }}
      />

      {error && <p style={{ color: "#c0392b", fontSize: 13, margin: "6px 0" }}>{error}</p>}
      {success && <p style={{ color: "#27ae60", fontSize: 13, margin: "6px 0" }}>{success}</p>}

      <button
        type="submit"
        disabled={submitting}
        style={{
          marginTop: 10,
          padding: "10px 28px",
          background: "#233d81",
          color: "#fff",
          border: "none",
          borderRadius: 8,
          fontWeight: 600,
          fontSize: 14,
          cursor: submitting ? "not-allowed" : "pointer",
          opacity: submitting ? 0.7 : 1,
        }}
      >
        {submitting ? "Submitting…" : "Submit Review"}
      </button>
    </form>
  );
}
